// @ts-ignore
import Icona from 'components/corporatiu/ui/Icona';
// @ts-ignore
import Imatge from 'components/3catinfo/Imatge';
// @ts-ignore
import CompteEnrere from 'components/corporatiu/CompteEnrere';
import __isEmpty from 'lodash/isEmpty';
import clsx from 'clsx';
import styles from './capcalera.module.scss';
import { CapcaleraProps } from './Capcalera.types';

const Capcalera = (props: Readonly<CapcaleraProps>) => {
    const { titol, subtitol, data, lloc, compteEnrere, estil, className, tipus } = props;

    const stylesCapcalera = clsx({
        [styles.capcalera]: true,
        [styles[estil as string]]: !!estil,
        [styles[tipus as string]]: !!tipus,
        [className as string]: !!className
    });

    if (tipus === 'patrocini') {
        return (
            <div className={styles.patrocini}>
                <div className={styles.patrociniText}>Amb el suport de</div>
                <div className={styles.patrociniLogo}>
                    <Imatge
                        src='/_resources/imatges/corporatiu/enviu/logo_gencat.svg'
                        width={226}
                        height={31}
                        alt='logo Generalitat de Catalunya'
                        priority={true}
                    />
                </div>
            </div>
        );
    }

    return (
        <div className={stylesCapcalera}>
            <div className={styles.capcaleraWrapper}>
                <div className={styles.contentEsquerra}>
                    <h1 className={styles.logo}>
                        <Imatge
                            src='/_resources/imatges/corporatiu/enviu/logo-enviu.svg'
                            width={350}
                            height={282}
                            alt={titol}
                            priority={true}
                        />
                    </h1>
                    <div className={styles.claim}>
                        <span>Ho veus,</span>
                        <span>ho sents,</span>
                        <span>ho vius</span>
                    </div>
                </div>
                <div className={styles.contentDreta}>
                    <div className={styles.sotstitol}>{subtitol}</div>
                    <div className={styles.dia}>{data}</div>
                    <div className={styles.lloc}>
                        <div className={styles.llocWrapper}>
                            <Icona
                                className={styles.icona}
                                icona='ubicacio'
                                alt='marcador localització'
                                isBlanc={true}
                                path='corporatiu'
                                mida='24'
                            />
                            <span>{lloc}</span>
                        </div>
                    </div>
                    <CompteEnrere mostrar={!__isEmpty(compteEnrere)} {...compteEnrere} className={styles.compteEnrere} />
                </div>
            </div>
        </div>
    );
};

export default Capcalera;
